import i18n from 'i18next';
import viTranslate from './vi/tran.json';
import enTranslate from './en/tran.json';
import { initReactI18next } from 'react-i18next';

export const resources = {
  en: {
    translation: enTranslate,
  },
  vi: {
    translation: viTranslate,
  },
} as const;

i18n.use(initReactI18next).init({
  lng: 'vi',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});
